import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LegalSidebar from '../components/LegalSidebar';
import { setPageSEO } from '../utils/seo.js';
import './Terms.css';

function TermsOfUse() {
  useEffect(() => setPageSEO({
    title: 'Terms of Use - Clientalio',
    description: "Review the terms governing your access to and use of Clientalio's testimonial collection and management platform.",
    canonical: 'https://clientalio.com/terms-of-use',
    ogTitle: 'Terms of Use - Clientalio',
    ogDescription: "Review the terms governing your access to and use of Clientalio's testimonial collection and management platform.",
    twitterTitle: 'Terms of Use - Clientalio',
    twitterDescription: "Review the terms governing your access to and use of Clientalio's testimonial collection and management platform."
  }), []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-header">
          <h1>Website Terms & Use</h1>
          <p className="last-updated">Last Updated: 06-Oct-2025</p>
        </div>
        <div className="terms-layout">
          <LegalSidebar activePage="terms-of-use" />

          {/* Main Content */}
          <div className="terms-content">
            <div className="content-section">

              <section className="terms-section">
                <h2>1. Introduction</h2>
                <p>
                  Welcome to Clientalio. By accessing or using our website and services, you agree
                  to comply with and be bound by these Terms of Use. Please read them carefully
                  before using our platform.
                </p>
                <p>
                  We are committed to transparency and privacy. Clientalio takes a number of steps
                  to comply with global data protection laws, including the General Data
                  Protection Regulation (GDPR) and other applicable privacy regulations.
                </p>
                <p>
                  For detailed information about how we handle your personal data, please review
                  our latest legal documents below:
                </p>
                <ul className="legal-links">
                  <li><Link to="/terms-and-condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/cookie-policy">Cookie Policy</Link></li>
                </ul>
              </section>

              <section className="terms-section">
                <h2>2. About Us</h2>
                <p>
                  Clientalio is a platform that helps individuals and businesses to collect
                  authentic video and text testimonials from clients in a simple and secure way.
                </p>
                <p>
                  Features may include recording, uploading, sharing, reviewing, and embedding
                  testimonials on websites or social media.
                </p>
                <p>
                  We reserve the right to modify or discontinue any feature, temporarily or
                  permanently, without prior notice.
                </p>
                <p>
                  When you use Clientalio to collect testimonials from your clients, you act as
                  the Data Controller for any data collected from your customers. We act as your
                  Data Processor, meaning we only process, store, and manage your client data
                  strictly to provide our service to you.
                </p>
                <p>
                  We do not:
                </p>
                <ul>
                  <li>Send marketing or promotional messages to your clients</li>
                  <li>Share or sell client data with third parties</li>
                  <li>Access or modify testimonial content unless required for technical or support purposes</li>
                </ul>
              </section>

              <section className="terms-section">
                <h2>3. Accessing Our Website</h2>
                <p>
                  Our servers and databases are securely hosted and maintained over cloud. We use
                  a limited number of trusted third-party providers. Every third-party service
                  provider we engage with is contractually bound to comply with applicable data
                  protection standards and maintain strict data security.
                </p>
              </section>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;
